var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdjustify(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "70 325 472 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f29724;\n      }\n\n      .st1 {\n        fill: #110b79;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TXTcMY.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.27,426.54c1.76-.88,3.61-2.61,5.11-3.93,12.49-10.97,25.77-24.51,38.75-34.46,5.62-4.31,7.74-2.48,12.5,1.39,13.11,10.63,27.14,23.48,39.69,34.91.81.74,1.74,1.62,2.31,2.55h-74.7l11.83-10.64h34.1l-20.58-17.97-32.33,28.37-16.68.25v-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.95,391.37l-6.82,9.26c-7.92.51-16.69-.7-24.51-.02-.79.07-2.53.24-3.14.57-1.04.56-1.15,2.83-.58,3.64,1.25,1.78,22.62.52,26.46.9,2.21.22,5.94,1.57,7.45,3.21,3.62,3.95,2.74,12.34-1.68,15.49-.94.67-5.3,2.57-6.23,2.57h-38.28l6.82-9.26,27.75.02c3.94-.46,4.47-4.27-.13-4.98-8.07-1.24-24.89,2.4-30.75-3.11-4.52-4.26-3.44-12.54,1.72-15.9,1.21-.79,5.61-2.39,6.88-2.39h35.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.59,427v-22.21h11.6v12.96h14.61c.18,0,3.05-.96,3.48-1.15,7.38-3.31,6.1-12.66-1.53-15.14-.53-.17-3.05-.83-3.35-.83h-24.36l7.19-9.26c8.96.59,19.22-1.58,27.6,2.09,14.11,6.18,13.81,24.7.32,31.31-.98.48-5.82,2.23-6.58,2.23h-29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.27,391.37v20.13c0,1.37.92,3.95,2.08,4.87,3.15,2.51,17.88,2.73,20.9,0,.31-.28,1.61-2.4,1.61-2.56v-22.44h11.6v22.44c0,4.25-4.03,9.35-7.74,11.26-10.17,5.22-39.59,4.43-39.59-11.72v-21.98h11.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "479.52 391.37 472.33 400.63 450.75 400.63 450.75 405.25 477.2 405.25 471.17 414.04 450.75 414.04 450.75 427 439.15 427 439.15 391.37 479.52 391.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.46,362.22c-.63-.53-3.87-2.52-4.07-2.87-.54-.92.39-3.35-.34-4.53l-11.83-9.26v7.63l16.24,12.96v10.87c-.96-.19-3.63-2.1-3.94-2.78-.69-1.51.32-3.54-.67-4.89l-11.63-8.99v7.87l16.7,12.72v11.34c-1.01-.62-3.98-2.32-4.4-3.24-.63-1.4.26-3.15-.67-4.42l-11.63-8.99v7.17l17.17,13.88v10.41c-1.28-.24-4.11-2.44-4.67-3.44-.7-1.25-.22-2.1-.53-3.17-.54-1.86-9.71-7.37-11.28-9.58l-1.38,1.38-4.41-3.93v-53.9l21.34,17.35v10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.88,391.37h14.38l-20.88,23.83v11.8h-11.6v-11.8l-21.81-23.83h14.61c1.72,1.72,12.24,15.03,13.41,14.79l11.88-14.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "417.81 391.37 411.08 400.63 398.33 400.63 398.33 427 386.73 427 386.73 400.63 370.49 400.63 377.22 391.37 417.81 391.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.03,391.37v19.66c0,1.56-.85,5.31-1.5,6.84-2.01,4.79-9.5,9.13-14.51,9.13h-19.72l6.59-9.15c3.57-.08,17.53.8,17.53-4.96v-21.51h11.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 421.52,
    y: 391.37,
    width: 11.13,
    height: 35.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.71,450.59l6.75-11.54c2.41-2.06,4.86-1.74,6.14,1.23,2.11,4.87,2.86,11.68,4.74,16.79l-5.98-.04-3.06-11.06c-1.44,2.16-4.86,10.82-7.06,11.48-5.52,1.66-6.98-7.78-9.65-11.01-1.06-.2-.57.47-.75,1.08-.46,1.56-1.93,8.44-2.49,9.11-.83.99-4.42.23-5.81.45,1.71-5.16,2.62-11.89,4.74-16.79,1.19-2.75,4.02-3.51,6.14-1.23,2.22,2.39,4.45,8.56,6.29,11.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.27,438.1c.48.43-2.68,4.73-3.58,4.99-2.29.67-14.2-.62-14.98.56-.26.39.22,1.85.69,1.85h12.99c.59,0,3.5,1.02,4.11,1.46,1.97,1.42,2.2,4.63,1.34,6.75-.37.91-3.28,3.36-4.06,3.36h-21.11l3.48-5.09h16.01v-2.31h-14.15c-.59,0-3.68-1.66-4.17-2.32-1.55-2.12-.93-6.36,1.38-7.86.49-.31,3.36-1.38,3.72-1.38h18.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.18,397.85v-34.7c.68-.12,1.14.12,1.72.36.99.42,9.48,5.59,10.06,6.16.64.64.66.58.77,1.54.22,1.85.17,15.95-.27,16.91-2.9,2.6-5.76,5.46-8.82,7.86-1,.78-2.17,1.98-3.47,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.97,457.07h-21.34l3.48-5.09h7.19l-3.78-6.18-1.08-.76-8.83,12.03h-6.73l12.53-17.81c2.38-2.21,4.94-2.07,6.95.47l11.61,17.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.79,438.1l-3.58,5.1c-4.38.21-17.28-1.96-14.88,6.14.26.86,2.59,2.64,3.38,2.64h15.08l-3.94,5.09c-4.8-.43-10.78,1.01-15.19-1.05-6.42-3.01-7.76-11.62-1.72-15.81,1-.69,4.24-2.11,5.31-2.11h15.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.27,386.28c-.29.34-4.13-2.79-4.44-3.21-.53-.7-.81-1.14-.69-2.09l.04-42.12c.28-1.47,3.75-3.57,5.09-4.41v51.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "233.62 438.1 233.62 451.99 248.01 451.99 244.53 457.07 227.59 457.07 227.59 438.1 233.62 438.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.2,344.18v38.17l-4.64,3.47v-37.25c0-1.12,3.21-4.28,4.64-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.77,340.01v40.72h-4.18v-37.71c0-.67,3.23-3.42,4.18-3.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 322.24,
    y: 438.1,
    width: 6.03,
    height: 18.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.72,364.07v35.4c0,.17-2.29,1.84-2.78,1.62v-34.93c0-.17,1.78-1.67,2.09-2.08h.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.69,370.09v34.47c0,.34-2.01,2.09-2.78,1.62v-34.01c0-.17,1.78-1.67,2.09-2.08h.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.15,403.87v-34.93c0-.16,1.85-1.9,2.32-2.08v34.93c0,.16-1.85,1.9-2.32,2.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 120.88,
    y: 409.42,
    width: 5.11,
    height: 5.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 127.38,
    y: 409.42,
    width: 5.11,
    height: 5.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.99,403.4v5.09s-5.11,0-5.11,0c-.47-3.55,1.55-5.57,5.11-5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.49,408.49h-5.11s0-5.09,0-5.09c3.56-.59,5.3,1.74,5.11,5.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustify);
export default __webpack_public_path__ + "static/media/adjustify.fb3bb9793fdda12a7a910f04f8724d1f.svg";
export { ForwardRef as ReactComponent };